// Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
export default function deepFreeze<T extends object>(object: T) {
    // Retrieve the property names defined on object
    const propNames = Reflect.ownKeys(object) as (keyof T)[];

    // Freeze properties before freezing self
    propNames.forEach((name) => {
        const value = object[name];

        if ((value && typeof value === 'object') || typeof value === 'function') {
            deepFreeze(value);
        }
    });

    return Object.freeze(object);
}
